import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-checkbox-pressed",
  "use": "ico-checkbox-pressed-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"ico-checkbox-pressed\">\n  <rect id=\"ico-checkbox-pressed_Rectangle_527\" data-name=\"Rectangle 527\" width=\"34\" height=\"34\" rx=\"5\" fill=\"#48c1a6\" />\n  <path id=\"ico-checkbox-pressed_Path_1412\" data-name=\"Path 1412\" d=\"M6.365,22.836l6.186,5.4,10.9-12.3\" transform=\"translate(2.093 -5.083)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol